import React from "react";
import { Paper, Box } from "@mui/material";
import IdCardRenderer from "./id-card/components/IdCardRenderer";

const CertificatePreview: React.FC<{ html: string; certificateType?: string }> = ({ html, certificateType }) => {
  if (certificateType === "STUDENT_ID") {
    // The html prop here might be the full HTML string or just the body
    // IdCardRenderer expects either templateHtml + data OR full html.
    // If backend returns full HTML for preview, IdCardRenderer handles it.
    return (
      <Paper sx={{ p: 2, display: 'flex', justifyContent: 'center', background: '#f5f5f5', minHeight: '300px', alignItems: 'center' }}>
        <IdCardRenderer html={html} />
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Box dangerouslySetInnerHTML={{ __html: html }} />
    </Paper>
  );
};

export default CertificatePreview;
